"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = exports.Footer = exports.Container = exports.Body = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: grid;\n  grid-auto-rows: 1fr;\n  grid-template-columns: 1fr;\n  grid-template-rows: 34px 1fr 100%;\n  gap: 0px 0px;\n  grid-template-areas:\n    \"header\"\n    \"body\"\n    \"footer\";\n  font-family: ", ", sans-serif;\n  font-size: 12px;\n"])), _variables.FontFamily.RobotoMedium);

exports.Container = Container;

var Header = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  grid-area: header;\n  background: #8a6caa;\n  color: #ffffff;\n  border-radius: 5px 5px 0px 0px;\n  display: flex;\n  align-items: center;\n"])));

exports.Header = Header;

var Body = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  grid-area: body;\n  border-left: 1px solid #f0f0f0;\n  border-right: 1px solid #f0f0f0;\n"])));

exports.Body = Body;

var Footer = _styledComponents.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  grid-area: footer;\n  display: flex;\n  align-items: center;\n  border: 1px solid #f0f0f0;\n  border-radius: 0 0 5px 5px;\n"])));

exports.Footer = Footer;